import { render, staticRenderFns } from "./AdministrarView.vue?vue&type=template&id=7f04760a"
import script from "./AdministrarView.vue?vue&type=script&lang=js"
export * from "./AdministrarView.vue?vue&type=script&lang=js"
import style0 from "./AdministrarView.vue?vue&type=style&index=0&id=7f04760a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports